import "@/styles/globals.css";
import type { AppProps } from "next/app";
import { ReactQueryProvider } from "@/providers/ReactQueryProvider";
import React, { useEffect } from "react";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CookieManager } from "@/components/CookieConsent";
import { loadGoogleAnalytics, updateAnalyticsConsent, trackPageView } from "@/utils/analytics";
import { getCookieConsent } from "@/utils/cookieConsent";
import { useRouter } from "next/router";

export default function App({ Component, pageProps }: AppProps) {
  const router = useRouter();

  useEffect(() => {
    
    const initAnalytics = async () => {
      const consent = getCookieConsent();
      
      if (consent?.analytics && process.env.NEXT_PUBLIC_GOOGLEANALYTICS) {
        try {
          await loadGoogleAnalytics(process.env.NEXT_PUBLIC_GOOGLEANALYTICS);
        } catch (error) {
          console.error('Failed to load Google Analytics:', error);
        }
      }
    };

    initAnalytics();

    
    const handleConsentUpdate = () => {
      const consent = getCookieConsent();
      if (consent && process.env.NEXT_PUBLIC_GOOGLEANALYTICS) {
        updateAnalyticsConsent(consent.analytics, consent.marketing);
        
        
        if (consent.analytics && !document.querySelector(`script[src*="gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLEANALYTICS}"]`)) {
          loadGoogleAnalytics(process.env.NEXT_PUBLIC_GOOGLEANALYTICS);
        }
      }
    };

    window.addEventListener('cookie-consent-updated', handleConsentUpdate);
    return () => {
      window.removeEventListener('cookie-consent-updated', handleConsentUpdate);
    };
  }, []);

  
  useEffect(() => {
    const handleRouteChange = (url: string) => {
      trackPageView(url);
    };

    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  return (
    <>
      <ReactQueryProvider>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          transition={Slide}
        />
        <Component {...pageProps} />
        <CookieManager />
      </ReactQueryProvider>
    </>
  );
}
